<template>
  <div
    class="total-price-shadow bg-background-neutral-secondary sticky bottom-0 -ml-4 flex w-[calc(100%+32px)] items-center justify-between rounded-t-xl px-4 py-3"
  >
    <div class="space-y-1.5">
      <div class="flex items-center space-x-2">
        <p
          v-price="totalPrice"
          class="text-text-neutral-primary text-base font-bold"
        ></p>
        <p
          v-if="showOriginalPrice"
          v-price="totalOriginalPrice"
          class="text-text-neutral-quaternary text-xs font-medium line-through"
        ></p>
      </div>
      <p class="text-text-neutral-primary text-xs">
        {{ $t('ancillaries.baggages.totalPrice') }}
      </p>
    </div>
    <FreeButton
      type="button"
      size="sm"
      class="green-main-button w-1/2"
      @click="emit('onAncillariesSave')"
    >
      {{ $t('general.save') }}
    </FreeButton>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { FreeButton } from 'freedom-shared';

  const emit = defineEmits<{ onAncillariesSave: [] }>();
  const props = defineProps<{
    totalPrice: number;
    totalOriginalPrice?: number;
  }>();

  const showOriginalPrice = computed(
    () =>
      Boolean(props.totalOriginalPrice) &&
      Number(props.totalOriginalPrice) > props.totalPrice,
  );
</script>

<style scoped>
  .total-price-shadow {
    box-shadow: 0px 2px 20px 0px #0000000d;
  }
</style>
